import React from 'react';
import { Copy, Terminal } from 'lucide-react';

interface ApiCardProps {
  method: 'GET' | 'POST' | 'PUT' | 'DELETE';
  endpoint: string;
  description: string;
  payload?: object;
}

const ApiCard: React.FC<ApiCardProps> = ({ method, endpoint, description, payload }) => {
  // Mapeo de colores según el método HTTP
  const colors = {
    GET: 'text-green-400 bg-green-400/10 border-green-400/20',
    POST: 'text-blue-400 bg-blue-400/10 border-blue-400/20',
    PUT: 'text-yellow-400 bg-yellow-400/10 border-yellow-400/20',
    DELETE: 'text-red-400 bg-red-400/10 border-red-400/20',
  };

  return (
    <div className="group mb-6 bg-white/[0.03] backdrop-blur-md border border-white/10 rounded-2xl p-6 hover:bg-white/[0.05] transition-all duration-300">
      <div className="flex flex-wrap items-center justify-between gap-4 mb-4">
        <div className="flex items-center gap-3">
          <span className={`px-3 py-1 rounded-md text-xs font-bold border ${colors[method]}`}>
            {method}
          </span>
          <code className="text-gray-300 font-mono text-sm bg-black/30 px-2 py-1 rounded">
            {endpoint}
          </code>
        </div>
        <button className="text-gray-500 hover:text-white transition-colors">
          <Copy size={16} />
        </button>
      </div>

      <p className="text-gray-400 text-sm mb-4 leading-relaxed">
        {description}
      </p>

      {payload && (
        <div className="relative">
          <div className="absolute right-3 top-3 text-white/20">
            <Terminal size={14} />
          </div>
          <pre className="bg-black/40 rounded-xl p-4 text-xs font-mono text-blue-200/80 overflow-x-auto border border-white/5">
            {JSON.stringify(payload, null, 2)}
          </pre>
        </div>
      )}
    </div>
  );
};

export default ApiCard;